var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7291 10.073L19.5206 7.56416C19.6851 7.45529 19.9119 7.49311 20.027 7.64865C20.0698 7.70642 20.0928 7.77524 20.0928 7.84577V16.1503C20.0928 16.3402 19.9299 16.4941 19.7291 16.4941C19.6545 16.4941 19.5817 16.4724 19.5206 16.4319L15.7291 13.923V16.8105C15.7291 17.1903 15.4035 17.498 15.0019 17.498H4.82005C4.41839 17.498 4.09277 17.1903 4.09277 16.8105V7.18555C4.09277 6.80585 4.41839 6.49805 4.82005 6.49805H15.0019C15.4035 6.49805 15.7291 6.80585 15.7291 7.18555V10.073ZM15.7291 12.2447L18.6382 14.1697V9.82645L15.7291 11.7514V12.2447ZM5.54732 7.87305V16.123H14.2746V7.87305H5.54732Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPermission);
export default __webpack_public_path__ + "static/media/VideoPermission.c1a76d2ff4bef026ac98a9c61109e3d1.svg";
export { ForwardRef as ReactComponent };